import { z } from 'zod';

export const LoginValidatorSchema = z.object({
  email: z.string(),
  password: z.string().min(4).optional(),
  originUrl: z.string().optional(),
  isEmbedded: z.boolean().optional(),
});

export type LoginValidator = z.infer<typeof LoginValidatorSchema>;

export const LoginValidatorSchemaV2 = z.object({
  email: z.string(),
  password: z.string().min(4).optional(),
  originUrl: z.string().optional(),
  isEmbedded: z.boolean().optional(),
});

export type LoginValidatorV2 = z.infer<typeof LoginValidatorSchemaV2>;
